import { UserManagerSettings } from 'oidc-client-ts'

const resolveFromOriginMap = (envValue: string | undefined): string => {
  if (!envValue) return ''

  try {
    const map = JSON.parse(envValue)
    const currentHostname = window.location.hostname
    return map[currentHostname] ?? map['default'] ?? ''
  } catch {
    // Backward compatibility: treat as simple string if not valid JSON
    return envValue
  }
}

export const sentinelConfig: UserManagerSettings = {
  authority: resolveFromOriginMap(process.env.REACT_APP_AUTH_AUTHORITY),
  client_id: resolveFromOriginMap(process.env.REACT_APP_IDX_CLIENT_ID),
  redirect_uri: `${window.location.origin}/admin`,
  response_type: 'code',
  scope: 'openid profile email',
  post_logout_redirect_uri: `${window.location.origin}/admin`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silent-refresh.html`,
  extraQueryParams: {
    kc_idp_hint: 'uhg-ms-id', // Hardwiring MSID as idp_hint
  },
}
